import { headerScrollListenter } from './sticky-header'
import { heightText } from './height-text'
import { scrollToTops } from './scroll-to-top'
import { tableWrapper } from './table-wrapper'
import './animate'

document.addEventListener('DOMContentLoaded', () => {
  headerScrollListenter()
  heightText()
  scrollToTops()
  tableWrapper()
})



// WEBPACK FOOTER //
// ./src/js/components/js-component/index.js